import Utils from "./utils";
import $ from 'jquery';

class Historic {

	/**
	 * @param options
	 */
	constructor() {
		Utils.debug('HISTORIC :: construct');


		if($('.historic').length > 0) {

			this.$historicTitles = $('.historic__info__title');
			this.$historicTexts = $('.historic__info__text');
			this.data = [];
			this.tl = gsap.timeline();
			this.tlFreeze = gsap.timeline();
			this.tlFreezeLine = gsap.timeline();
			this.counterObj = {
				historic : []
			}
			let self = this;
			$('.historic').each(function (index) {
				self.counterObj.historic.push({'counter' : 0, 'oldCounter' : 0, 'subTextCounter' : 0});
				$(this).attr('data-index', index)
				self.data[index] = $(this).find('.historic__info').data('datas');
				self.initContent($(this), index);

				/*TODO fix temporaire*/
				$(this).find('.historic__date__item__line--progress').first().css('transform', 'translate(0px, 0px)');
				$(this).find('.historic__date__item__circle').first().addClass('circleActive');

			})

			$('#app').on('click', '.historic__info__pagination li', function () {
				let $element = $(this);
				let parentIndex = $element.parents('.historic').attr('data-index');
				self.counterObj.historic[parentIndex].subTextCounter = $element.index();
				$element.parent().find('li').removeClass("active");
				$element.addClass('active');
				self.animTransition($element.parents('.historic'), parentIndex, false);
			})


			$('#app').on('click', '.historic__date__item', function () {
				let $parent = $(this).parents('.historic');
				let parentIndex = $parent.attr('data-index');
				self.counterObj.historic[parentIndex].counter = $(this).index();
				self.counterObj.historic[parentIndex].subTextCounter = 0;
				self.animTransition($parent, parentIndex, true);
			})
		}

	}

	initContent($historic, index) {
		this.appendContent($historic, index);
		this.appendPagination($historic, index);
		this.initFreezeLine($historic, index);
	}


	appendContent($historic, index) {
		let arrayCounter = this.counterObj.historic[index];
		$historic.find('.historic__info__title').html($($historic.find('.historic__date__item__number')[arrayCounter.counter]).text())
		$historic.find('.historic__info__text').html(this.data[index][arrayCounter.counter][arrayCounter.subTextCounter]);
	}

	appendPagination($historic, index) {
		var $pagination = $historic.find('.historic__info__pagination')
		$pagination.html('');
		var i;
		for(i = 0; i < this.data[index][this.counterObj.historic[index].counter].length; i++) {
			if (i === 0) {
				$pagination.append('<li class="active"></li>')
			} else {
				$pagination.append('<li></li>')
			}
		}
	}

	initFreezeLine($historic, index) {
		this.tlFreezeLine.clear();
		let counter = this.counterObj.historic[index].counter;
		let oldCounter = this.counterObj.historic[index].oldCounter;
		let isReverse = false;
		let arrayItems = [];
		let i;
		let $line = $historic.find('.historic__date__item__line--progress');
		let $items = $historic.find('.historic__date__item');
		$line.removeClass('historic__date__item__line--complete');

		if(counter < oldCounter) {
			//console.log('reverse')
			isReverse = true
			for (i = counter; i < oldCounter; i++) {
				var y = i+1
				arrayItems.push($items[y]);
			}
		} else {
			//console.log('not reverse')
			for (i = oldCounter; i <= counter; i++) {
				var test = i+1
				arrayItems.push($items[i]);
			}
		}

		if(isReverse)
			arrayItems.reverse();


		arrayItems.forEach((element, index) => {
			if(!isReverse) {
				this.tlFreezeLine.add([
					gsap.to($(element).find('.historic__date__item__line--progress'), {scaleX:1, ease: 'Expo.easeInOut'})
				])
			} else {
				this.tlFreezeLine.add([
					gsap.to($(element).find('.historic__date__item__line--progress'), {scaleX:0, ease: 'Expo.easeInOut'})
				])
			}
			this.tlFreezeLine.add(() => {
				$(element).find('.historic__date__item__circle').removeClass('wasCircleActive');
				$(element).find('.historic__date__item__circle').removeClass('circleActive');
			})

			if(isReverse) {
				this.tlFreezeLine.add(() => {
					$($items[counter]).find('.historic__date__item__circle').addClass('circleActive');
				})
			} else {
				if(counter > index) {
					this.tlFreezeLine.add(() => {
						$(element).find('.historic__date__item__circle').addClass('wasCircleActive');
					})
				} else if (counter === index) {
					this.tlFreezeLine.add(() => {
						$(element).find('.historic__date__item__circle').addClass('circleActive');
					})
				}
			}
		})

		this.counterObj.historic[index].oldCounter = counter;

	}


	animTransition($historic, index, isAllTransition) {

		/*TODO check si y'a pas moyen de rendre ça plus propre*/
		this.tl.clear();

		if (isAllTransition) {
			this.tl.add([
				gsap.to($historic.find('.historic__info__title'), {xPercent: -50, autoAlpha:0, duration:.25}),
				gsap.to($historic.find('.historic__info__text'), {xPercent: -50, autoAlpha:0,  duration:.25})

			]);
		} else {
			this.tl.add([
				gsap.to($historic.find('.historic__info__text'), {xPercent: -50, autoAlpha:0,  duration:.25})
			]);
		}

		this.tl.add( () => {
			if(isAllTransition) {
				this.initContent($historic, index)
			} else {
				this.appendContent($historic, index);
			}
		});

		if(isAllTransition) {
			this.tl.add([
				gsap.to($historic.find('.historic__info__title'), {xPercent: 0, x:0, ease: 'Expo.easeInOut'}),
				gsap.to($historic.find('.historic__info__text'), {xPercent: 0, ease: 'Expo.easeInOut'}),
			]);

			this.tl.add([
				gsap.to($historic.find('.historic__info__title'), {autoAlpha:1, ease: 'Expo.easeInOut'}),
				gsap.to($historic.find('.historic__info__text'), {autoAlpha:1, ease: 'Expo.easeInOut'}),
			]);
		} else {
			this.tl.add([
				gsap.to($historic.find('.historic__info__text'), {xPercent: 0, ease: 'Expo.easeInOut'}),
			]);

			this.tl.add([
				gsap.to($historic.find('.historic__info__text'), {autoAlpha:1, ease: 'Expo.easeInOut'}),
			]);
		}

	}
}

module.exports = Historic;
